import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../../Core/RichText';

import { Card, StyledCtas, Img, Heading } from './styles';

const header = {
  renderNode: {
    [BLOCKS.PARAGRAPH]: (_, children) => <Heading>{children}</Heading>,
  },
};

const FeatureCardCarousel = ({ as = null, className = '', data = null }) => {
  if (!data) return false;

  const {
    id,
    component,
    imageDam,
    heading,
    bodyCopy,
    ctas,
    textAlignment,
    cardClassName,
  } = data;

  return (
    <Card
      key={id}
      className={`${className} ${cardClassName} ${component} ${textAlignment}`}
      as={as}
    >
      {imageDam && <Img src={imageDam} alt="" role="presentation" />}
      {heading && <RichText document={heading} options={header} />}
      {bodyCopy && <RichText document={bodyCopy} />}
      {ctas && <StyledCtas ctas={ctas} alignment="start" />}
    </Card>
  );
};

FeatureCardCarousel.propTypes = {
  as: PropTypes.string,
  className: PropTypes.string,
  data: PropTypes.shape(),
};

export default FeatureCardCarousel;
